<template>
  <div class="companies">
    <h4>{{ $t('graphs.companies') }}</h4>
    <b-tabs class="tabs">
      <b-tab
        v-for="(chart, index) in charts"
        :key="index"
        :title="chart.title"
        class="item-graph"
      >
        <canvas :id="chart.id"></canvas>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'CompaniesGraph',
  // eslint-disable-next-line vue/require-prop-types
  props: ['period'],

  data() {
    return {
      charts: [
        {
          id: 'bookingscount',
          type: 'bar',
          options: [],
          labels: [],
          chart: [],
          update: false,
          title: this.$t('graphs.requests_number'),
          colors: [
            'rgb(239, 83, 80)',
            'rgb(41, 182, 246)',
            'rgb(153, 153, 153)',
            'rgb(255, 112, 67)',
            'rgb(149, 117, 205)',
          ],
        },
        {
          id: 'drivercount',
          type: 'bar',
          options: [],
          labels: [],
          chart: {},
          title: this.$t('graphs.driver_number'),
          colors: [
            'rgb(149, 117, 205)',
            'rgb(239, 83, 80)',
            'rgb(41, 182, 246)',
            'rgb(153, 153, 153)',
            'rgb(255, 112, 67)',
          ],
        },
        {
          id: 'moneycount',
          type: 'bar',
          data: [],
          title: this.$t('graphs.income'),
          chart: [],
          stacked: true,
          colors: [
            'rgb(149, 117, 205)',
            'rgb(239, 83, 80)',
            'rgb(41, 182, 246)',
            'rgb(153, 153, 153)',
            'rgb(255, 112, 67)',
          ],
        },
      ],
    }
  },

  mounted() {
    this.$watch('period', this.fetch, { deep: true, immediate: true })
  },

  methods: {
    fetch() {
      this.$uiBlocker(
        this.$http
          .get('charts/companiesdata', {
            params: {
              from: this.period.gte,
              to: this.period.lte,
              division_id: this.currentDivision.id,
            },
          })
          .then(({ data }) => {
            this.draw(data)
          }),
        this.$el,
      )
    },

    draw(data) {
      this.charts.forEach(chart => {
        let ctx = document.getElementById(chart.id).getContext('2d')

        this.setOptions(chart, data)

        let graph
        graph = chart.chart

        if (Object.keys(graph).length !== 0) {
          graph.destroy()
        }
        if (chart.stacked) {
          this.createStackedBar(ctx, chart)
        } else {
          this.createBarGraph(ctx, chart)
        }
      })
    },

    setOptions(chart, data) {
      if (chart.id === 'bookingscount' || chart.id === 'drivercount') {
        chart.labels = []
        chart.options = []

        chart.labels = Object.keys(data[chart.id])
        chart.options = Object.values(data[chart.id])
      }
      if (chart.id === 'moneycount') {
        chart.data = []
        chart.data = data[chart.id]
      }
    },

    createBarGraph(ctx, chart) {
      let graph = new Chart(ctx, {
        type: chart.type,
        barPercentage: 12,
        data: {
          labels: chart.labels,
          datasets: [
            {
              data: chart.options,
              backgroundColor: chart.colors,
              borderWidth: 2,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
            xAxes: [
              {
                barPercentage: 0.4,
              },
            ],
          },
        },
      })
      chart.chart = graph
      graph.update()

      return graph
    },

    createStackedBar(ctx, chart) {
      let data = chart.data
      let labels = []
      let cash = []
      let stripe = []
      let graph

      data.forEach(info => {
        labels.push(info.name)
        cash.push(info.cash)
        stripe.push(info.stripe)
      })

      graph = new Chart(ctx, {
        type: chart.type,
        barPercentage: 12,
        data: {
          labels: labels,
          datasets: [
            {
              data: cash,
              label: this.$t('graphs.cash'),
              backgroundColor: '#66bb6a',
              borderWidth: 2,
            },
            {
              data: stripe,
              label: this.$t('graphs.stripe'),
              backgroundColor: 'rgb(149, 117, 205)',
              borderWidth: 2,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                stacked: true,
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
            xAxes: [
              {
                stacked: true,
                barPercentage: 0.4,
              },
            ],
          },
        },
      })
      graph.update()
      chart.chart = graph

      return graph
    },
  },
}
</script>

<style lang="scss">
.companies {
  h3 {
    text-align: center;
  }
}
</style>
